<template>
  <div class="d-flex flex-column align-center">
    <v-date-picker @input="userSelectedDate" id="date-picker" v-model="date" class="picker" :class="cardClass()"
      show-adjacent-months :locale="locale" :min="allowedDates.min" :max="allowedDates.max"
      :weekday-format="formatWeekdates" :title-date-format="formatDateHeader"></v-date-picker>

    <div class="mt-5" v-if="options.allow_unknown">
      <unknown-button id="date-unknown" @click="setUnknown"></unknown-button>
    </div>
  </div>
</template>

<script>
import ui from '@/mixins/ui'
import UnknownButton from '@/components/widgets/UnknownButton.vue'
import { mapActions } from 'vuex'

export default {
  name: 'datepicker',
  components: { UnknownButton },
  mixins: [ui],
  model: {
    prop: 'items',
    event: 'click'
  },
  data() {
    return {
      date: null,
      isUnknown: false,
      locale: this.$store.state.v4.language.selected,
      allowedDates: {
        min: null,
        max: null
      },
      defaultDate: null
    }
  },
  props: {
    'options': Object,
    'items': Array,
    'panelName': String
  },
  computed: {
    autoProgress() {
      return this.$store.state.settings.engagements_features.autoProgress
    }
  },
  methods: {
    setDefaultDate() {
      const referenceDays = {
        today: () => {
          const offsetTz = (new Date()).getTimezoneOffset() * 60000
          const dateLocalTz = (new Date(Date.now() - offsetTz))
          return dateLocalTz
        },
        lmp: () => {
          return new Date(this.allowedDates.max)
        }
      }
      const refDay = referenceDays[this.options.defaultReference]()
      this.defaultDate = new Date(refDay.setDate(refDay.getDate() + this.options.defaultOffset)).toISOString()
    },
    setMinMaxDates(minmax) {
      const offsetDays = this.options.offsets[minmax]
      if (offsetDays !== null) {
        const offsetTz = (new Date()).getTimezoneOffset() * 60000
        const referenceDateUtc = this.date ? new Date(this.date) : new Date()
        const refDateLocalTz = new Date(referenceDateUtc.getTime() - offsetTz)
        this.allowedDates[minmax] = new Date(refDateLocalTz.setDate(refDateLocalTz.getDate() + offsetDays)).toISOString()
      }
    },
    userSelectedDate(newValue) {
      this.isUnknown = false;
      this.date = newValue;
      this.setResponseValue();
      this.$track(this.$analyticsEvents.DATE_SELECTED, {
        component: 'DatePicker',
        panel_name: this.panelName,
        selected_date: newValue,
        min_date: this.allowedDates.min,
        max_date: this.allowedDates.max
      })
    },
    setInitialDate() {
      if (this.items[0].unknown) {
        this.setUnknown()
      } else {
        this.date = this.items[0].selected ?
          this.items[0].value.slice(0, 10) :
          this.date = this.defaultDate.slice(0, 10)
      }
    },
    setUnknown() {
      this.isUnknown = true;
      this.date = this.defaultDate.slice(0, 10)
      this.items[0].selected = true
      this.items[0].value = new Date(this.date).toISOString()
      this.items[0].unknown = true
      this.$track(this.$analyticsEvents.DATE_UNKNOWN_SELECTED, {
        component: 'DatePicker',
        panel_name: this.panelName,
        auto_progressed: this.autoProgress
      })
      if (this.autoProgress) {
        this.next()
      }
    },
    setResponseValue() {
      this.items[0].value = new Date(this.date).toISOString()
      this.items[0].selected = true
      this.items[0].unknown = false
    },
    formatWeekdates(dateString) {
      return new Date(dateString).toLocaleString(this.locale, { weekday: 'short', timeZone: 'UTC' });
    },
    formatDateHeader(dateString) {
      if (this.isUnknown) {
        return this.$t("app.inputs.unknown.display");
      }
      return new Date(dateString).toLocaleString(this.locale, { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' });
    },
    ...mapActions({ next: 'v4/navigate/next' })
  },
  watch: {
    panelName: function () {
      this.isUnknown = false;
      this.setInitialDate();
    }
  },
  created() {
    this.setMinMaxDates('min')
    this.setMinMaxDates('max')
    this.setDefaultDate()
    this.setInitialDate()
  }
}
</script>
